var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Mixins, Prop } from 'vue-property-decorator';
import BaseTable from '@/components/base/BaseTable.vue';
import TableMixin from '@/mixins/table-mixin';
import SteppedPageMixin from '@/mixins/stepped-page-mixin';
import { TYPES } from '@/dependency-injection/types';
import { ValidationObserver } from 'vee-validate';
import ValidatedTextField from '@/components/shared/ValidatedTextField.vue';
import ValidatedTextarea from '@/components/shared/ValidatedTextarea.vue';
import ValidatedAutocomplete from '@/components/shared/ValidatedAutocomplete.vue';
import ValidatedCheckbox from '@/components/shared/ValidatedCheckbox.vue';
import DatePicker from '@/components/shared/DatePicker.vue';
var VendorMaterialAssociationsTable = /** @class */ (function (_super) {
    __extends(VendorMaterialAssociationsTable, _super);
    function VendorMaterialAssociationsTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headers = [
            { text: 'Vendor', value: 'vendorId', width: '25%' },
            { text: 'Material', value: 'materialId', width: '25%' },
            { text: 'May Contain<br/>Up To 5% Bio', value: 'mayContain', width: '10%' },
            { text: 'Unit Of Measure', value: 'unitOfMeasure', width: '10%' },
            { text: 'Pricing Formula(s)', sortable: false, width: '10%' },
            { text: 'Notes', sortable: false, width: '10%' },
            { text: 'Actions', sortable: false, width: '10%' },
        ];
        _this.pricingFormulaHeaders = [
            { text: 'Start Date', value: 'start', width: '20%' },
            { text: 'End Date', value: 'end', width: '20%' },
            { text: 'Pricing Formula', value: 'formula', width: '50%' },
            { text: 'Actions', sortable: false, width: '10%' },
        ];
        _this.expandedType = 'pricingFormulas';
        return _this;
    }
    VendorMaterialAssociationsTable.prototype.beforeMount = function () {
        this.serviceSymbol = TYPES.ContractManagementService;
    };
    VendorMaterialAssociationsTable.prototype.expandRow = function (type, expanded, expandRowFunction) {
        if (expanded && type !== this.expandedType) {
            this.expandedType = type;
            return;
        }
        this.expandedType = type;
        expandRowFunction();
    };
    VendorMaterialAssociationsTable.prototype.openSidesheet = function (item, mode) {
        var contractManagementService = this.service;
        // add the contract id to the default pricing formula
        var data = item
            ? __assign({}, item)
            : contractManagementService.getDefaultVendorMaterial();
        data.contractId = this.contractId;
        this.openCrudSidesheet(data, mode);
    };
    VendorMaterialAssociationsTable.prototype.openAddVendorMaterialPricingFormulaSidesheet = function (item, mode) {
        var contractManagementService = this.service;
        var data = contractManagementService.getDefaultVendorMaterialPricingFormula();
        data.contractVendorMaterialXrefId = item.contractVendorMaterialXrefId;
        this.openCrudSidesheet(data, mode);
    };
    VendorMaterialAssociationsTable.prototype.openEditVendorMaterialPricingFormulaSidesheet = function (item, mode) {
        var contractManagementService = this.service;
        var data = __assign({}, item);
        this.openCrudSidesheet(data, mode);
    };
    Object.defineProperty(VendorMaterialAssociationsTable.prototype, "vendorMaterialAssociations", {
        get: function () {
            var vendorMaterials = this.item.vendorMaterials;
            return vendorMaterials;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: Number, required: true }),
        __metadata("design:type", Number)
    ], VendorMaterialAssociationsTable.prototype, "contractId", void 0);
    VendorMaterialAssociationsTable = __decorate([
        Component({
            components: {
                'validation-observer': ValidationObserver,
                'validated-text-field': ValidatedTextField,
                'validated-text-area': ValidatedTextarea,
                'validated-autocomplete': ValidatedAutocomplete,
                'validated-checkbox': ValidatedCheckbox,
                'date-picker': DatePicker,
                'base-table': BaseTable,
            },
        })
    ], VendorMaterialAssociationsTable);
    return VendorMaterialAssociationsTable;
}(Mixins(TableMixin, SteppedPageMixin)));
export default VendorMaterialAssociationsTable;
